'use client';
import React from 'react';
import AppLayout from '@/components/AppLayout';
import AdminFinanceContent from './components/AdminFinanceContent';

export default function AdminFinancePage() {
  return (
    <AppLayout activePath="/admin/finance">
      <AdminFinanceContent />
    </AppLayout>
  );
}
